<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <template slot="left">
                    <table-searcher v-model="filter.rolename"
                        placeholder="请输入岗位名称"
                        style="margin-left: 10px;"
                        @search="search">
                    </table-searcher>
                </template>
                <Button v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd">
                    新增
                </Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height='mtHeight'>
                <template v-slot:action="{ row }">
                    <Button v-if="$can('update')"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickInfo(row)">修改</Button>
                    <PoptipButton v-if="$can('delete') && row.sys === 0"
                        text="删除"
                        transfer
                        placement="top-end"
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() =>rowConfirmdelete(row)"></PoptipButton>
                </template>
            </Table>
            <!-- 弹出层 -->
            <smart-modal :maskClosable="maskClosable"
                :title="roleId ? '岗位详情' : '新增岗位'"
                :height="300"
                :width="600"
                v-model="showRoleForm"
                @close-by-confirm="fetch">
                <role-form v-if="showRoleForm"
                    :pid="pid"
                    :id="roleId"></role-form>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { mapCell } from "_c/grid/renderCell"
import { roleList, roleDelete } from "@/api/user-manager"
import RoleForm from "./form"
import Enum from "_u/enum"

const PAGE_SIZE = 20
export default {
    components: {
        RoleForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                rolename: ""
            },
            page: {
                list: []
            },
            dict: {},
            modal: {},
            maskClosable: false,
            showRoleForm: false,
            roleId: "",
            pid: "0"
        }
    },

    computed: {
        columns() {
            return [{
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60
                },
                {
                    key: "name",
                    title: "岗位名称",
                    align: "left",
                    minWidth: 100
                },
                {
                    key: "remark",
                    title: "备注",
                    align: "left",
                    minWidth: 120
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    slot: "action",
                    minWidth: 120
                }
            ]
        }
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                40
        })
    },

    methods: {
        changeStatus(row) {
            roleEnabled(row.id)
                .then(() => {
                    this.$Message.success(this.$t("tips.update.success"))
                })
                .finally(() => this.fetch())
        },
        fetch() {
            this.loading = true
            roleList(this.filter)
                .then(args => {
                    this.setTableData(args.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.page.pageNo = 1
            this.fetch()
        },

        setTableData(data) {
            this.page.list = data.list
        },
        fillData(args) {
            var [role] = args
            this.setTableData(role.data)
        },

        onClickAdd(e) {
            this.roleId = ""
            this.pid = "0"
            this.showRoleForm = true
        },

        rowClickInfo(row) {
            this.roleId = row.id
            this.pid = row.pid
            this.showRoleForm = true
        },
        rowConfirmdelete(row) {
            this.loading = true
            roleDelete(row.id)
                .then(() => {
                    this.$Message.success(this.$t("tips.delete.success"))
                })
                .finally(() => this.fetch())
        }
    },
    created() {
        this.fetch();
    },
}
</script>